/* eslint-disable no-constant-condition */
import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import { Box, Button, Container, Dialog } from '@mui/material';
import classNames from 'classnames';
import Logo from '../../images/Transmit@2x.png';

import colorVariables from '../../styles/variables';

import { topNavZIndex } from '../../styles/styles';

import theme from '../../styles/theme';
import useUser from '../../hooks/useUser';
import { isLoggedIn } from '../../services/user-service';
import Account from './account';
import useAccount from '../../hooks/useAccount';

import RequestDemoModal from '../request-demo-modal';

import styles from '../composer/site-components/site.module.css';

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: colorVariables.white,
    flexGrow: 1,
    zIndex: topNavZIndex,
    position: 'sticky',
    top: '0',
  },
  appBar: {
    position: 'absolute',
    backgroundColor: 'rgb(255 255 255 / 85%)',
    backdropFilter: 'saturate(180%) blur(20px)',
    padding: '8px 0',
    '&.MuiPaper-root': {
      boxShadow: 'none',
    },
  },
  toolBar: {
    height: '46px',
    minHeight: '46px',
    padding: '0 20px',

    [theme.breakpoints.down('md')]: {
      padding: '0 4px',
    },
  },
  logo: {
    margin: '0px 16px 0 0',
    height: '32px',
  },
  logoContainer: {
    height: '32px',
    width: '157px',
  },
  services: {
    height: '40px',
    lineHeight: '40px',
    fontSize: '15px',
    color: colorVariables.composerLinkBlack,
    alignItems: 'center',
  },
  serviceName: {
    whiteSpace: 'nowrap',
    color: colorVariables.composerLinkBlack,
    '&:hover': {
      color: colorVariables.composerLinkHoverPurple,
    },
    margin: '0 24px 0 24px',

    '&.active': {
      color: colorVariables.composerLinkHoverPurple,
    },
  },
  f1: {
    flex: 1,
  },
}));

const HomeTopNav = () => {
  const classes = useStyles();

  useUser();
  useAccount();

  const [anchorElNav, setAnchorElNav] = useState(null);

  const [demoOpen, setDemoOpen] = useState(false);
  const handleDemoOpen = () => {
    setAnchorElNav(null);
    setDemoOpen(true);
  };

  const handleDemoClose = () => {
    setDemoOpen(false);
  };

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  // const pages = [
  //   { page: 'Overview', location: '/overview' },
  //   { page: 'Features', location: '/features' },
  //   { page: 'Pricing', location: '/pricing' },
  //   { page: 'Resources', location: '/resources' },
  //   { page: 'FAQs', location: '/faqs' },
  // ];

  const pages = [
    { page: 'Stream Composer', location: '/stream-composer' },
    { page: 'Reach Extension', location: '/reach-extension' },
    { page: 'Creative Studio', location: '/creative-studio' },
    // { page: 'API', location: '/api' },
  ];

  //const menuPages = [...pages, { page: 'Login', location: '/login' }, { page: 'Sign up', location: '/sign-up' }];
  const menuPages = [...pages];

  return (
    <div className={classes.root}>
      <AppBar position="static" classes={{ root: classes.appBar }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters classes={{ root: classes.toolBar }}>
            <a href="/" className={classes.logoContainer}>
              <img className={classes.logo} src={Logo} alt="transmit" />
            </a>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map(({ page, location }) => (
                <NavLink key={page} to={`${location}`} className={classes.serviceName}>
                  {page}
                </NavLink>
              ))}
            </Box>

            <div className={classes.f1} />

            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <Button
                variant="contained"
                disableElevation
                className={classNames(styles.keyButton)}
                onClick={handleDemoOpen}
              >
                Request a Demo
              </Button>
              <RequestDemoModal open={demoOpen} handleClose={handleDemoClose} />
            </Box>

            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              {isLoggedIn() && false ? (
                <Account />
              ) : (
                <Box>
                  <Button
                    className={styles.menuButton}
                    size="large"
                    aria-haspopup="true"
                    onClick={handleOpenNavMenu}
                    aria-label="menu"
                  >
                    {anchorElNav ? <CloseIcon /> : <MenuIcon />}
                  </Button>
                  <Dialog open={Boolean(anchorElNav)} onClose={handleCloseNavMenu} hideBackdrop>
                    <div className={styles.navMenu}>
                      <div className={styles.buttonWrap}>
                        <Button
                          variant="contained"
                          disableElevation
                          className={classNames(styles.keyButton)}
                          onClick={handleDemoOpen}
                        >
                          Request a Demo
                        </Button>
                      </div>
                      {menuPages.map(({ page, location }) => (
                        <Link
                          key={location}
                          to={location}
                          onClick={() => {
                            setAnchorElNav(null);
                          }}
                        >
                          {page}
                        </Link>
                      ))}
                    </div>
                  </Dialog>
                </Box>
              )}
            </Box>

            {/* <Box sx={{ display: { xs: 'none', md: 'flex' } }}>{renderLoginSignUp()}</Box> */}
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};

HomeTopNav.defaultProps = {};

HomeTopNav.propTypes = {};

export default HomeTopNav;
